import "./header.scss";

const selectors = {
  header: "[data-header]",
  menuTrigger: "[data-header-trigger]",
  active: "active",
};

const initHeader = () => {
  const header = document.querySelector(selectors.header);
  const headerMenuTriggers = document.querySelectorAll(selectors.menuTrigger);

  headerMenuTriggers?.forEach((trigger) =>
    trigger.addEventListener("click", () => {
      header.classList.toggle(selectors.active);
    })
  );
};

document.addEventListener("DOMContentLoaded", async function () {
  initHeader();
});
